/* ==========================================================================
   THE SILENT GOLF SHOP — "WIN98" THEME LAYER — INTERACTIONS
   ==========================================================================
   HOW TO INSTALL
   1. In the theme code editor, under Assets, add a new blank asset named
      win98-interactions.js and paste this file in.
   2. In layout/theme.liquid, just above the closing </body> tag, add:
        <script src="{{ 'win98-interactions.js' | asset_url }}" defer></script>
   3. No dependencies, no build step, ~1kb. Safe to remove at any time by
      deleting that one script tag — the CSS layer works fine without it.
   ========================================================================== */

document.addEventListener("DOMContentLoaded", function () {
  // 1. Pressed-button feedback (mousedown/up, not just CSS :active,
  //    so it also works reliably on touch)
  document.querySelectorAll("button, .button, input[type='submit']").forEach(function (el) {
    el.addEventListener("pointerdown", function () {
      el.classList.add("win98-pressed");
    });
    ["pointerup", "pointerleave"].forEach(function (evt) {
      el.addEventListener(evt, function () {
        el.classList.remove("win98-pressed");
      });
    });
  });

  // 2. Populate a status bar with real, non-decorative info if one exists
  //    on the page (e.g. product count on collection pages).
  var statusBar = document.querySelector(".win98-statusbar");
  if (statusBar) {
    var count = document.querySelectorAll(".product-card-wrapper").length;
    if (count > 0) {
      var countLabel = document.createElement("span");
      countLabel.textContent = count + (count === 1 ? " item" : " items");
      statusBar.appendChild(countLabel);
    }
  }

  // 3. Active/inactive window title bar state — dims when a window
  //    doesn't have focus/hover, matching classic OS behavior.
  document.querySelectorAll(".win98-window").forEach(function (win) {
    var titlebar = win.querySelector(".win98-window__titlebar");
    if (!titlebar) return;
    win.addEventListener("mouseenter", function () {
      titlebar.style.background = "var(--win-titlebar)";
    });
    win.addEventListener("mouseleave", function () {
      titlebar.style.background = "var(--win-titlebar-inactive)";
    });
  });
});